import { getLink } from "../../../utils/utils";

import translator from "./translator";

const content = {
  esp: (
    `
    <div class="poem">
      <p class="poem-block refreno mb-3">
        <span class="italic bold">Rf:</span> <br/>
        Diru, ho mia bela, <br/>
        Kien navigos ni? <br/>
        Levis flugilon velo, <br/>
        Karesas nin juni’.
      </p>

      <p class="poem-block mb-4">
        La remilo ebura, <br/>
        La flageto purpura, <br/>
        Direktilo el or’. <br/>
        En ŝipkelo – vanilo, <br/>
        Sur ferdek’ – suna brilo, <br/>
        Blanka vel’ – la flugilo <br/>
        De l’ anĝelo en glor’.
      </p>

      <p class="poem-block refreno mb-4">
        <span class="italic bold">Rf.</span>
      </p>

      <p class="poem-block mb-4">
        - Ĉu vi volas al Lima, <br/>
        Al Ĉini’ malproksima, <br/>
        Al Norvega rokar’? <br/>
        Aŭ florkronojn ni plektos, <br/>
        Sunradiojn kolektos <br/>
        Aŭ la konkojn el mar’?
      </p>

      <p class="poem-block refreno mb-4">
        <span class="italic bold">Rf.</span>
      </p>

      <p class="poem-block mb-3">
        - Ni navigu sub velo <br/>
        Al river’ de l’ Fidelo, <br/>
        Kie am’ por ĉiam’. <br/>
        - Sed ĉi tiu rivero <br/>
        Ne ekzistas en vero <br/>
        En la Land’ de la Am’!
      </p>
    </div>
    `
  )
}

const itemName = {
  esp: 'Diru, ho mia bela'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemVideo: ['JH2523XOfV4'],
    itemTranslator: `
      Franca kanto <br/>
      ${translator.esp}
    `
  }
}

export default item;